module.exports = __webpack_public_path__ + "static/img/sh.6560d76b.svg";